import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=381760c9&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=381760c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381760c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381760c9')) {
      api.createRecord('381760c9', component.options)
    } else {
      api.reload('381760c9', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=381760c9&scoped=true&", function () {
      api.rerender('381760c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AnmJhTc5nBgO/JS/comp/SearchFilterTokens.vue"
export default component.exports